import { useContext, useEffect, useRef, useState } from "react";
import { Card, Form, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ContextData } from "../containers/shipments/shipments";
import ReactTooltip from "react-tooltip";
import { canViewIndiaIec, IEC_GRID_KEYS } from "@utils/utils";
const isIecColumn = (item) => Array.isArray(item?.field_name) && item.field_name.some((field) => IEC_GRID_KEYS.includes(field));

const ShipmentConfigureModal = ({ showModal, closeModal, showBolFilter }) => {
  const { customShipmentGridCostomizeOption, customShipmentGridSelectedList, setCustomShipmentGridList, type, setType } = useContext(ContextData);
  const userEmail = useSelector((state) => state.userDetails?.userData?.email) ?? "";
  const creditDetails = useSelector((state) => state.userDetails?.creditDetails);
  const canViewIec = canViewIndiaIec(userEmail, creditDetails);
  const [itemList, setItemList] = useState([]);
  const [customOptions, setCustomOptions] = useState({});
  const [currentType, setCurrentType] = useState(null);

  let droppedPositionIndex = useRef(null);
  let draggedItemIndex = useRef(null);
  // storing data coming from country template using context api
  useEffect(() => {
    if (customShipmentGridSelectedList) {
      const selectedList = JSON.parse(JSON.stringify(customShipmentGridSelectedList));
      setItemList(canViewIec ? selectedList : selectedList.filter((item) => !isIecColumn(item)));
    }
    if (customShipmentGridCostomizeOption) {
      let options = JSON.parse(JSON.stringify(customShipmentGridCostomizeOption));
      if (!canViewIec) {
        options = Object.fromEntries(Object.entries(options).map(([header, fields]) => [header, Array.isArray(fields) ? fields.filter((item) => !isIecColumn(item)) : fields]));
      }
      setCustomOptions(options);
      setCurrentType(Object.keys(options)[0]);
    }
  }, [type, canViewIec]);

  // used to handle the reorder logic
  const handleDrop = () => {
    setTimeout(() => {
      if (draggedItemIndex.current !== null && droppedPositionIndex.current !== null && itemList[draggedItemIndex.current] && itemList[droppedPositionIndex.current] && droppedPositionIndex.current !== draggedItemIndex.current) {
        let tempList = [...itemList];
        tempList.splice(draggedItemIndex.current, 1);
        tempList.splice(droppedPositionIndex.current, 0, itemList[draggedItemIndex.current]);
        setItemList([...tempList]);
      }
      droppedPositionIndex.current = null;
      draggedItemIndex.current = null;
    }, 20);
  };
  // handle change of the input checkbox
  const onCheckboxClick = (item, checked) => {
    let tempArr = [...itemList];
    let isPresent = false;
    for (let i = 0; i < itemList.length; i++) {
      if (itemList[i].label_name.toLowerCase() === item.label_name.toLowerCase()) {
        isPresent = true;
      }
    }
    if (checked && !isPresent) {
      item.is_selected = true;
      tempArr.push(item);
    } else if (!checked && isPresent) {
      tempArr = [...tempArr.filter((id) => id.label_name.toLowerCase() !== item.label_name.toLowerCase())];
    }
    setItemList([...tempArr]);
  };
  // handle delete item from the reorder list
  const removeItem = (index) => {
    let tempArr = [...itemList];
    tempArr.splice(index, 1);
    setItemList([...tempArr]);
  };
  // check if the item is present in the selected list or not
  const checkIfChecked = (item) => {
    let isPresent = false;
    for (let i = 0; i < itemList.length; i++) {
      if (itemList[i].label_name.toLowerCase() === item.label_name.toLowerCase()) {
        isPresent = true;
        return true;
      }
    }
    return isPresent;
  };

  return (
    <>
      <Modal
        id="custom-shipment-grid-modal"
        size="xl"
        centered
        show={showModal}
        onHide={() => {
          closeModal("reset");
        }}
        animation={false}>
        <Modal.Header>
          <Modal.Title className="w-100">
            Select columns for your grid.
            <span className="header-alert">*You can select and display maximum of 15 columns.</span>
            <span className="float-right">
              <img className="mr-2 cursor-pointer" onClick={() => closeModal("reset")} alt="clear icon" src="https://res.cloudinary.com/drzta9shk/image/upload/v1689255207/intel/icons/main_cross_b6z9yy.svg" />
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showBolFilter ? (
            <div className="container d-flex align-items-center mt-3 custom-grid-searchtype-options">
              <span>Select view for the grid</span>
              <div className="custom-grid-searchtype-options-container">
                <Form.Group controlId="typeOfContacts" className="m-0">
                  {/* <Form.Label>Select view for the grid</Form.Label> */}
                  <div className="row col-md-12 p-0 m-0" onChange={(e) => setType(e.target.value)}>
                    <div className="col-md-3 px-0">
                      <Card>
                        <Card.Body className="p-2 pl-4">
                          <div className="form-check">
                            <input checked={type === "bol"} className="form-check-input" type="radio" name="flexRadioDefault1" id="bol" value={"bol"} />
                            <span className="pseudo-checkmark"></span>
                            <label className="form-check-label" htmlFor="bol">
                              Aggregated by Bill of Lading
                            </label>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-md-3">
                      <Card>
                        <Card.Body className="p-2 pl-4">
                          <div className="form-check">
                            <input checked={type === "shipments"} className="form-check-input" type="radio" name="flexRadioDefault1" id="shipments" value={"shipments"} />
                            <span className="pseudo-checkmark"></span>
                            <label className="form-check-label" htmlFor="shipments">
                              Shipment level
                            </label>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                  {/* {error && error.typeOfContacts ? <span className='error'>{error.typeOfContacts}</span> : <></>} */}
                </Form.Group>
              </div>
            </div>
          ) : (
            <></>
          )}
          <div className="d-flex">
            {/* item checkbox section */}
            <div className="col-md-8 column-select-container">
              <div className="column-type-strip">
                <div className="column-type-container">
                  {Object.keys(customOptions).map((item) => (
                    <>
                      <span onClick={() => setCurrentType(item)} className={currentType === item ? "column-type selected text-capitalize" : "column-type text-capitalize"}>
                        {item.replaceAll("_", " ").toLowerCase()}
                      </span>
                    </>
                  ))}
                </div>
              </div>
              {customOptions && customOptions[currentType] && Array.isArray(customOptions[currentType]) ? (
                <div className="checkbox-container">
                  {customOptions[currentType].map((item) => (
                    <label className="form-check">
                      <span data-tip={item.is_fixed === true ? "This is a mandatory field and cannot be removed" : !checkIfChecked(JSON.parse(JSON.stringify(item))) && itemList.length >= 15 ? "You have reached the maximum limit of 15 columns" : ""} data-for={"customgridtip" + item.label_name}>
                        <input className={(!checkIfChecked(JSON.parse(JSON.stringify(item))) && itemList.length >= 15) || item.is_fixed === true ? "disabled form-check-input" : "form-check-input"} type="checkbox" checked={checkIfChecked(JSON.parse(JSON.stringify(item)))} onChange={(e) => onCheckboxClick(JSON.parse(JSON.stringify(item)), e.target.checked)} disabled={(!checkIfChecked(JSON.parse(JSON.stringify(item))) && itemList.length >= 15) || item.is_fixed === true} />
                      </span>
                      <span data-for={item.label_name + "elipsis"} data-tip={item.label_name.length > 25 ? item.label_name : ""}>
                        {item.label_name.length > 25 ? item.label_name.slice(0, 25) + "..." : item.label_name}
                      </span>
                      <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="right" id={item.label_name + "elipsis"} />
                      <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="right" id={"customgridtip" + item.label_name} />
                    </label>
                  ))}
                </div>
              ) : (
                <></>
              )}
            </div>
            {/* reorder section */}
            <div className="col-md-4 selected-item-reorder-section">
              <span className="selected-item-reorder-section-header d-block">Selected columns to display in grid with their sequence</span>
              {itemList && itemList.length >= 15 ? <span className="small-font">You have reached the maximum limit of 15 columns</span> : itemList && itemList.length < 5 ? <span className="small-font">You have to select minimum 5 columns</span> : <></>}
              <div className="scrollable-section">
                {itemList && itemList.length ? (
                  itemList.map((item, index) => {
                    return (
                      <div
                        draggable
                        className="selected-items"
                        onDrop={(e) => {
                          e.preventDefault();
                          handleDrop();
                        }}
                        onDragOver={(e) => {
                          e.preventDefault();
                        }}
                        onDragEnter={(e) => {
                          e.preventDefault();
                          droppedPositionIndex.current = index;
                        }}
                        onDragEnd={(e) => {
                          e.preventDefault();
                          draggedItemIndex.current = index;
                        }}>
                        <span className="tw-flex tw-items-center">
                          <span className="drag-icon">
                            <img className="mr-2" alt="drag icon" src="https://res.cloudinary.com/drzta9shk/image/upload/v1689255207/intel/icons/drag_indicator_tllj12.svg" />
                          </span>
                          {item.label_name}
                        </span>
                        <span>
                          {item.is_fixed !== true ? (
                            <span onClick={() => removeItem(index)} className="float-right">
                              <img className="mr-2 cursor-pointer" alt="clear icon" src="https://res.cloudinary.com/drzta9shk/image/upload/v1689255226/intel/icons/small_cross_hrgbom.svg" />
                            </span>
                          ) : (
                            <></>
                          )}
                        </span>
                      </div>
                    );
                  })
                ) : (
                  <span>Please select columns for your grid</span>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2"
            onClick={() => {
              setCustomShipmentGridList(itemList, true, type);
              closeModal("reset");
            }}>
            Reset Default View
          </button>
          <button
            type="button"
            className="btn btn-primary btn-sm trademo-new-btn"
            disabled={itemList.length > 15 || itemList.length < 5}
            onClick={() => {
              setCustomShipmentGridList(itemList, false, type);
              closeModal();
            }}>
            {" "}
            Save Configuration
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ShipmentConfigureModal;
